module.exports = __webpack_public_path__ + "static/media/checkWhite.ebf9c572.svg";